import { benchmarkValues, spanishBenchmarkValues } from '../values/benchmarks';
import { SCALE_CONSTANTS, getPercentileValue } from '../functions/getPR';
import { getCutscorePercentiles } from './cutscores';
import { scaleORF } from './scaling';
import { locales } from "../../../constants/constants";

// TODO abstract and consolidate these constants
export const benchmarkTypes = {
  WCPM: 'WCPM',
  Lexile: 'Lexile',
  AREA: 'AREA',
  EVS: 'EVS',
  DRA: 'DRA',
  PSF: 'PSF',
  NWF: 'NWF',
  ESRI: 'ESRI',
  ARM: 'ARM',
}
export const seasons = {
  FALL: 'fall',
  WINTER: 'winter',
  SPRING: 'spring',
}

function getDistrictBenchmarks(benchmark, type, season,customBenchmarks) {
  let grade = benchmark.grade;
  let value = benchmark.value;
  let districtCutlines = customBenchmarks.district.cutlines.map(cutline => {
    let field = cutline.grades[grade].seasons.find(seasonField => {
      // TODO use same enum throughout UI so that this toLowerCase is unnecessary
      return seasonField.id.toLowerCase() == season;
    });
    let scaledValue = type === 'ORF' ?
      scaleORF(field.value, customBenchmarks.district.meta.scale, type) : field.value;
    return {
      value: scaledValue,
      label: cutline.label,
      id: benchmark.value,
    }
  });
  return districtCutlines;
}

function scaleValue(value, currentType, destinationType) {
  return value;
}

function getNationalNormBenchmarks(grade, scale, season, locale, selectedStatePercentileCuts) {
  // search for "ARM SPANISH SCORES" to find other places where ARM score is determined.
  if (SCALE_CONSTANTS[scale]) {
    const percentiles = getCutscorePercentiles(selectedStatePercentileCuts);
    let benchmarks = percentiles.map((perc) => {
      const value = getPercentileValue({
        percentile: perc,
        scale,
        grade,
        language: locale,
        window: season,
        useSeasonMap: false,
      })
      return {
        id: scale + '_' + season + '_' + grade,
        percentile: perc,
        value,
      }
    });
    return benchmarks;
  } else {
    // fallback to legacy method of cutline calculation
    const percentiles = [25, 50, 75];
    return percentiles.map((perc) => {
      const values = locale === locales.ES_MX ? spanishBenchmarkValues : benchmarkValues;
      const rawBench = values.find(b => b.Grade === grade && b.Percentile === perc);
      const benchmarkValue = rawBench[scale + '_' + season];
      return {
        id: scale + '_' + season + '_' + grade,
        value: benchmarkValue,
        percentile: perc,
      }
    })
  }
}

export function getScaledBenchmarkCutlines(benchmark, type, season, customBenchmarks, selectedLocale, selectedStatePercentileCuts) {
  let cutlines = [];
  if(benchmark && (benchmark.grade || benchmark.grade == 0)) {
    let benchmarkType = benchmark.value.substring(0, benchmark.value.length - 2);
    switch(benchmarkType) { // TODO add a case here for custom benchmark
      case 'District':
        cutlines = getDistrictBenchmarks(benchmark, type, season, customBenchmarks);
        break;
      case 'Spanish':
        cutlines = getNationalNormBenchmarks(benchmark.grade,type,season,locales.ES_MX, selectedStatePercentileCuts);
        break;
      case 'NationalNorms':
      default:
        cutlines = getNationalNormBenchmarks(benchmark.grade,type,season, selectedLocale, selectedStatePercentileCuts);
        break;
    }
  }

  // TODO: improve error handling, and null benchmark state passing
  let cutoffs;
  if(cutlines.length > 0) {
    cutoffs = {
      POOR: cutlines[0].value,
      AVERAGE: cutlines[1].value,
      GOOD: cutlines[2].value,
    };
  } else {
    cutoffs = {
      POOR: -1000,
      AVERAGE: -999,
      GOOD: -998,
    }
  }

  return { cutoffs, cutlines };
}

export default {
  getScaledBenchmarkCutlines,
  benchmarkTypes,
  seasons,
}